import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmailEvent } from 'src/app/shared/models/email-event';
import { DataService } from 'src/app/shared/services/data-service/data.service';
import { UserService } from 'src/app/shared/services/user-service/user.service';

@Component({
  standalone: false,
  selector: 'app-subscription-dashboard',
  templateUrl: './subscription-dashboard.component.html',
  styleUrls: ['./subscription-dashboard.component.scss'],
})
export class SubscriptionDashboardComponent implements OnInit {
  loading: boolean;
  allEvents: EmailEvent[];

  constructor(
    private dataService: DataService,
    private userService: UserService,
    private router: Router
  ) {
    this.loading = true;
  }

  async ngOnInit(): Promise<void> {
    // Check auth
    if (!(await this.userService.getUserDetail()).canViewAdminPage) {
      this.router.navigate(['/']);
    }

    // Get all email events
    this.allEvents = await this.dataService.getAllEvents();
    this.loading = false;
  }
}

